<script>

export default {
    props: {
        onMounted: {
            type: Function,
            required: true
        },
        perpage: {
            type: Number,
            default: 12,
            required: true
        },
        options: {
            type: Array,
            default: () => {
                return []
            },
            required: true
        },
    },
    methods: {
        setPerPage(value) {
            this.onMounted('perpage', value)
        }
    }
}
</script>

<template>
    <div title="Items Per Page">
        <b-dropdown id="dropdown-buttons" variant="outline-primary" class="m-2" no-caret>
            <template #button-content>
                {{ perpage + ' items' }} <i class="mdi mdi-chevron-down"></i> 
            </template>
            <b-dropdown-item-button v-for="option in options" :key="option" @click="setPerPage(option)">
                {{ option }}
            </b-dropdown-item-button>
        </b-dropdown>
    </div>
</template>
